import React from 'react';
import { withGoogleMap, GoogleMap, DirectionsRenderer, Circle } from 'react-google-maps';
import StaticMapPreviewContainer from '../Map/StaticMapPreviewContainer';
import config from '../../config';
import css from './DirectionsMap.css';

const DynamicMap = withGoogleMap(({ defaultCenter, directions }) => {
    const circleProps = {
        options: {
            fillColor: '#8f2593',
            fillOpacity: 0.2,
            strokeColor: '#8f2593',
            strokeOpacity: 0.5,
            strokeWeight: 1,
            clickable: false,
        },
        radius: 2500,
        center: defaultCenter,
    };

    return (
        <GoogleMap
            defaultZoom={12}
            defaultCenter={defaultCenter}
            options={{
                mapTypeControl: false,
                scrollwheel: false,
                fullscreenControl: false,
                streetViewControl: false,
            }}
        >
            <Circle {...circleProps} />
            {directions ? (
                <DirectionsRenderer
                    directions={directions}
                    options={{
                        polylineOptions: {
                            strokeColor: '#4285F4',
                            strokeOpacity: 0.8,
                            strokeWeight: 5,
                        },
                    }}
                />
            ) : null}
        </GoogleMap>
    );
});

const DirectionsMap = ({
    geolocation,
    directions,
    mapElement,
    renderContainerElement,
    useStaticMap,
    handleActivateDynamicMap,
    onKeyDown,
}) => {
    const defaultCenter = { lat: geolocation.lat, lng: geolocation.lng };

    const mapsConfig = {
        ...config.maps,
        fuzzy: {
            ...config.maps.fuzzy,
            enabled: true,
            defaultZoomLevel: 12,
            offset: 2500,
        },
    };

    if (useStaticMap) {
        return renderContainerElement(
            <StaticMapPreviewContainer
                onActivate={handleActivateDynamicMap}
                onKeyDown={onKeyDown}
                center={defaultCenter}
                zoom={12}
                mapsConfig={mapsConfig}
            />,
            { className: css.staticMapRoot }
        );
    }

    return (
        <DynamicMap
            geolocation={geolocation}
            defaultCenter={defaultCenter}
            directions={directions}
            mapElement={mapElement}
            containerElement={renderContainerElement()}
        />
    );
};

export default DirectionsMap;
